import { CreateUserInput } from '@map/hooks/userApi';
import { createContext, useContext } from 'react';

export type Values = Pick<CreateUserInput, 'email' | 'phone' | 'password'> & {
  role?: string;
  phoneVerificationCode: string;
  phoneVerificationRequest?: any;
};
export type PhoneVerificationRequestHandler = (newValues?: Partial<Values>) => Promise<unknown>;
type ContextValue = {
  values: Values;
  updateValues: (newValues: Partial<Values>) => void;
  submit: PhoneVerificationRequestHandler;
};

const RegistrationContext = createContext(null as any as ContextValue);
export const RegistrationContextProvider = RegistrationContext.Provider;

export const useRegistrationContext = () => useContext(RegistrationContext);
